import * as React from 'react';
import ContentTile from './ContentTile';

export default () => (
  <ContentTile color="#0067F4">
    {/* A gauge: two arcs open at the top right, a needle and its pivot. */}
    <path d="M12 3a9 9 0 1 0 6.364 2.636M12 7a5 5 0 1 0 3.536 1.464" />
    <path d="M12 12V3" />
    <circle cx="12" cy="12" r="1" />
  </ContentTile>
);
